import { useContext, useEffect, useState } from "react"
import { schoolContext } from "../providers/school.provider"
import { getRecoveriesLeft } from "../utils/firestore.utils"

// Quanti recuperi del corso della lezione (`courseType`) restano a ognuno di
// questi allievi nella sua stagione, `{ [playerID]: numero }`: un CAD si
// recupera in un CAD, un SAT in un SAT, e fuori dai corsi non si recupera.
// Chi non c'è ancora si sta leggendo: fino ad allora "Recupero" non si
// propone, e non si propone nemmeno se leggerli non riesce — si può sempre
// pagare in un altro modo.
const useRecoveriesLeft = (playerIDs, date, excludeLessonID, courseType) => {
	const { selectedSchool } = useContext(schoolContext)
	const [recoveries, setRecoveries] = useState({})

	const ids = [...new Set((playerIDs || []).filter(Boolean))]
	const idsKey = ids.join(",")
	const time = date?.getTime?.()

	useEffect(() => {
		if (!selectedSchool || !time || ids.length === 0) return
		let isCurrent = true

		// una lettura sola per tutti, solo delle loro lezioni con un'assenza o
		// un recupero
		getRecoveriesLeft(selectedSchool, ids, new Date(time), excludeLessonID, courseType)
			.then(left => {
				if (isCurrent) setRecoveries(prev => ({ ...prev, ...left }))
			})
			.catch(error => console.error("Recuperi degli allievi non letti:", error))

		return () => {
			isCurrent = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedSchool, idsKey, time, excludeLessonID, courseType])

	return recoveries
}

export default useRecoveriesLeft
